import { useMutation, UseMutationOptions } from "react-query";
import { axiosInstance } from "../../config/axios";
import {
  GetMerchantBankListRequest,
  GetMerchantBankListResponse,
} from "./_types";

export function useGetMerchantBankList(
  options?: UseMutationOptions<
    GetMerchantBankListResponse,
    unknown,
    GetMerchantBankListRequest
  >
) {
  return useMutation<
    GetMerchantBankListResponse,
    unknown,
    GetMerchantBankListRequest
  >(async (payload) => {
    const { data } = await axiosInstance.post("/MerchantBank/List", payload);
    return data;
  }, options);
}
